<template>
	<v-tooltip bottom>
		<template v-slot:activator="{ on }">
			<v-btn icon @click="$emit('action')">
				<v-icon small v-on="on" :class="iconClass" :color="iconColor">
					{{ icon }}
				</v-icon>
			</v-btn>
		</template>
		{{ name }}
	</v-tooltip>
</template>

<script>
export default {
  name: "PublicContestDataTableIcon",

  props: {
    name: {
      type: String, required: true
    },
    icon: {
      type: String, required: true
    },
    iconColor: {
      type: String, default: ''
    },
    iconClass: {
      type: String, default: ''
    },
  }
};
</script>

<style scoped>
  .yellow-icon {
    color: #cccc00 !important;
  }

  .green-icon {
    color: green !important;
  }

  .red-icon {
    color: red !important;
  }
</style>